module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hant_5-342e6357f4de8055c7a4cc6b65c87023.jpg";